import { useEffect } from "react"

const usePrompt = (when: boolean, message: string) => {
  // Simple implementation that only handles page refresh/close
  // For React Router navigation, we'll rely on the beforeunload event
  useEffect(() => {
    if (!when) return

    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      event.preventDefault()
      event.returnValue = message
      return message
    }

    // Add beforeunload listener for page refresh/close
    window.addEventListener("beforeunload", handleBeforeUnload)

    // Cleanup function
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload)
    }
  }, [when, message])
}

export default usePrompt
